import { APPLICANT_KIND } from '@flatsy/types/Applications/Applicant'
import { WizardContext, WizardEvent } from '../wizardMachine'
import { getLatestData } from '../Utils/GetLatestData'

export const isCoCandidat = (context: WizardContext, event: WizardEvent): boolean => {
  const { applicants } = getLatestData(context, event)
  if (applicants && applicants[context.index]) {
    const applicant = applicants[context.index]
    if (applicant.kind === APPLICANT_KIND.co_applicant) {
      return true
    }
  }
  return false
}
export const isGuarantor = (context: WizardContext, event: WizardEvent): boolean => {
  const { applicants, index } = getLatestData(context, event)
  if (applicants && applicants[index]) {
    const applicant = applicants[index]
    if (applicant.kind === APPLICANT_KIND.guarantor) {
      return true
    }
  }
  return false
}
